import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fourofour',
  templateUrl: './fourofour.component.html',
  styleUrls: ['./fourofour.component.scss']
})
export class FourofourComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
